import React from "react";

const Demo = () => {
  return (
    <div>
      <h2>Subject</h2>
      <div>
        <h4>Hi Customer Name</h4>
        <div>
          Sorry for the delay in response. We encountered an issue earlier today
          that affected a portion of accounts -- and unfortunately yours was one
          of those affected. We have rectified the underlying problem and you
          should be up and running again now. No conversations were lost during
          this time, but please give it a few minutes for them to flow into your
          inbox. We understand how critical we are in the role of supporting
          your customers, and will be implementing a host of solutions to ensure
          that a situation like this does not occur again. If you have any
          questions, please don't hesitate to give us a shout.
        </div>
        <div>
          <h4>Thanks</h4>
          <h4>KRISTIVE</h4>
        </div>
      </div>
    </div>
  );
};

export default Demo;
